// export const baseURL = process.env.REACT_APP_BE_URL
export const baseURL = `/api`
// export const apiUrl = process.env.REACT_APP_DETECTION_URL
export const apiUrl = `/api-detection`

// export const apiSegmentasi = process.env.REACT_APP_SEGMENTATION_URL
export const apiSegmentasi = `/api-segmentation`

export const apiBoneLoss = `/api-boneloss`

export const apiDentograph = `/api-dentograph`

export const apiKeyBoneLoss = `W4fYkMZkCxRm3MMhMR5KQ40tfxXfG4hxvaamqeU2BBc=`

export const satuSehatBaseURL = `${baseURL}/satu-sehat`;
export const satuSehatAuthURL = `${baseURL}/satu-sehat`;

// export const baseURL = "http://api.radiodiagnosis-report.me"
